export default "https://cdn-static.gokick.com/assets/9d5d62c9c10b295872f7f6ffd14ff177054c61a9/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";